import { useAppSelector } from '../../../redux/store';
import useGetData from '../../../Services/useGetData';
import globals from '../../../Globals.json';
import * as S from './styles';
import PanelLoading from '../../Loading/PanelLoading';
import { IProduct } from '../../../interfaces/IProduct';
import Format from '../../../Services/Format';
import { buildDashboardQuery, isRangeReady } from '../dateFilters';
import { MdImageNotSupported } from 'react-icons/md';

interface MostSaldProducts {
  product_id: number;
  total_quantity: string;
  total_sales: string;
  product: IProduct;

}

export function CategorySoldProducts({
  start,
  end,
  startDate,
  endDate,
  title
}: {
  start: number;
  end?: number;
  startDate: string;
  endDate: string;
  title: string
}) {
  const { stores, storeActive } = useAppSelector(
    ({ storeMeReducer }) => storeMeReducer.value
  );

  const path = globals?.api?.categorySoldProducts

  const rangeReady = isRangeReady(startDate, endDate);

  const { data, isFetching } = useGetData({
    path,
    query: buildDashboardQuery({
      storeId: storeActive?.id,
      startDate,
      endDate,
      limit: 20,
    }),
    enabled: !!storeActive?.id && rangeReady,
  });

  return (
    <S.Container>
      <div className="header">
        <h3>{title}</h3>
        <span className="details-link">Ver detalhes</span>
      </div>
      <div className="cards">
        {isFetching && !data ? (
          <PanelLoading />
        ) : data?.categories?.length > 0 ? (
          data?.categories?.slice(start, end)?.map((category: any, index: number) => (
            <div key={category?.id_pdv_category} className="wrapper">
              <div className="position">
                <span>{index + 1}º</span>
              </div>
              <div className="img">
                {category?.image ? (
                  <img
                    src={category.image}
                    alt={category?.category_name}
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.nextElementSibling?.classList.remove('hidden');
                    }}
                  />
                ) : null}
                <MdImageNotSupported
                  className={category?.image ? 'hidden' : ''}
                  size={22}
                />
              </div>
              <div className="description">
                <span className="name">{category?.category_name}</span>
              </div>
              <div className="details">
                <span className="sales">
                  {Format.formatCurrencyBr(category?.total_value)}
                </span>
                <span className="qtd">{category?.total_qty} pedido{Number(category?.total_qty) > 1 ? 's' : ''}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="not-data">Nenhuma venda no período selecionado.</div>
        )}
      </div>
    </S.Container>
  );
}
